<section class="seller-container">
  <section class="ids-pt-8">
    <h2 class="ids-text-title-01">salvar formulário</h2>
    <p class="ids-mv-4">Lembre de conferir seus dados com atenção antes de enviar</p>


      <ids-accordion class="custom-accordion" header="dados pessoais">
        <ng-container>
          <ul>
            <li class="ids-row ids-pv-4">
              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nome completo</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.name }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">CPF</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.documentNumber | idsMask: cpf }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">data de nascimento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.birth.date | idsMask : 'date' }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nacionalidade</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.birth.nationality }}
                </p>
              </section>

              <section class="ids-col-6" *ngIf="dataPersonal.birth.state">
                <h3 class="ids-text-label-small ids-pv-2">UF de nascimento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.birth.state }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">cidade de nascimento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.birth.city }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">gênero</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.gender | lowercase }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">profissão ou principal ocupação</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.profession | lowercase }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">estado civil</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.relationship.maritalStatus | lowercase }}
                </p>
              </section>

              <ng-container *ngIf="hasMarried">
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">regime de bens</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.relationship.propertyRegime | propertyRegimeLabel }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">data de casamento</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.relationship.marriageDate | idsMask : 'date' }}
                  </p>
                </section>
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">cônjuge vai receber alguma parte na venda do imóvel?</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.relationship.hasPartInSale | simNao }}
                  </p>
                </section>
              </ng-container>

              <ng-container *ngIf="!hasMarried">
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">convive em união estável?</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.relationship.hasStableUnion | simNao }}
                  </p>
                </section>
              </ng-container>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">documento</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">tipo de documento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.document.type }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nº do documento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.document.number }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">data de expedição</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.document.issueDate | idsMask : 'date' }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">órgão expedidor</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.document.issuingAuthority }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">UF de expedição</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.document.issuingAuthorityState }}
                </p>
              </section>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">filiação</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nome da mãe</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.parentage.motherName }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.parentage.fatherName">
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">nome do pai</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.parentage.fatherName }}
                  </p>
                </section>
              </ng-container>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">contato</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">e-mail</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.contact.email }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nº de celular</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.contact.phone | idsMask : phone }}
                </p>
              </section>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">endereço residencial</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">CEP</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.address.zipCode | idsMask : cep }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">endereço</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.address.street }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">número</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.address.number }}
                </p>
              </section>

              <section class="ids-col-6" *ngIf="dataPersonal.address.complement">
                <h3 class="ids-text-label-small ids-pv-2">complemento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.address.complement }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">bairro</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.address.district }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">cidade</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.address.city }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">estado</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.address.state }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">endereço para correspondência</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.deliveryAddress!.isLocale | residenciaOuOutro }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.deliveryAddress && !dataPersonal.deliveryAddress.isLocale ">
                <section class="ids-col-12">
                  <h2 class="ids-text-section-02">endereço de corresponência</h2>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">CEP</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.deliveryAddress.zipCode }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">endereço</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.deliveryAddress.street }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">número</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.deliveryAddress.number }}
                  </p>
                </section>

                <section class="ids-col-6" *ngIf="dataPersonal.deliveryAddress!.complement">
                  <h3 class="ids-text-label-small ids-pv-2">complemento</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.deliveryAddress.complement }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">bairro</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.deliveryAddress.district }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">cidade</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.deliveryAddress.city }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">estado</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.deliveryAddress.state }}
                  </p>
                </section>
              </ng-container>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">procurador</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">
                  o vendedor será representado por uma procuração?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.attorneyData!.useAttorney | simNao }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.attorneyData && dataPersonal.attorneyData.useAttorney">
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">nome procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.attorneyData.fullName }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">CPF / CNPJ procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.attorneyData.documentNumber | idsMask : maskCpfCnpj }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">e-mail procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.attorneyData.email }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">telefone procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.attorneyData.phone | idsMask : phone }}
                  </p>
                </section>
              </ng-container>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">dados bancários e adicionais</h2>
              </section>

              <section class="ids-col-12">
                <h3 class="ids-text-label-small ids-pv-2">
                  como pessoa física sou empregador, trabalhador autônomo ou produtor rural e
                  mantenho funcionários registrados a meu serviço?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.additionalInformation.hasEmployee | simNao }}
                </p>
              </section>

              <section class="ids-col-12">
                <h3 class="ids-text-label-small ids-pv-2">
                  a venda deste imóvel será para um dos herdeiros legais (filho(a), neto(a), nora,
                  etc.)?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.additionalInformation.isSellingToFamily | simNao }}
                </p>
              </section>

              <section class="ids-col-12">
                <h3 class="ids-text-label-small ids-pv-2">
                  este proprietário do imóvel se trata de um Espólio (pessoa falecida, cujo o bem
                  ainda não foi partilhado), interdito (aquele que, por determinação legal, não
                  responde por seus atos) ou menor de 18 anos?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.additionalInformation.isUnderAge | simNao }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.additionalInformation.isUnderAge">
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">que tipo de proprietário se trata?</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.additionalInformation.situation | lowercase }}
                  </p>
                </section>
              </ng-container>
            </li>
          </ul>
        </ng-container>
      </ids-accordion>

      <ids-accordion class="custom-accordion" header="dados do cônjuge ou companheiro" *ngIf="dataPersonal.partner">
        <ng-container class="content">
          <ul>
            <li class="ids-row">
              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nome completo</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.name }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">CPF</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.cpf | idsMask : cpf }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">data de nascimento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.birth.date | idsMask : 'date' }}
                </p>
              </section>

              <section *ngIf="dataPersonal.partner.birth.state" class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">UF de nascimento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.birth.state }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">cidade de nascimento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.birth.city }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nacionalidade</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.birth.nationality }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">gênero</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.gender | lowercase }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">profissão, ocupação ou atividade</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.profession | propertyRegimeLabel }}
                </p>
              </section>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">documento</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">tipo de documento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.document.type }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">número do documento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.document.number }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">data de expedição</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.document.issueDate | idsMask : 'date' }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">órgão expedidor</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.document.issuingAuthority }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">UF de expedição</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.document.issuingAuthorityState }}
                </p>
              </section>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">filiação</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nome da mãe</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.parentage.motherName }}
                </p>
              </section>

              <section class="ids-col-6" *ngIf="dataPersonal.partner.parentage.fatherName">
                <h3 class="ids-text-label-small ids-pv-2">nome do pai</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.parentage.fatherName }}
                </p>
              </section>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">contato</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">e-mail</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.contact.email }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">número de celular com DDD</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.contact.phone | idsMask : phone }}
                </p>
              </section>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">endereço residencial</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">CEP</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.address.zipCode | idsMask : cep }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">endereço</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.address.street }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">número</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.address.number }}
                </p>
              </section>

              <section class="ids-col-6" *ngIf="dataPersonal.partner.address.complement">
                <h3 class="ids-text-label-small ids-pv-2">complemento</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.address.complement }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">bairro</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.address.district }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">cidade</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.address.city }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">estado</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.address.state }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">endereço para correspondência</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.deliveryAddress!.isLocale | residenciaOuOutro }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.partner.deliveryAddress && !dataPersonal.partner.deliveryAddress.isLocale ">
                <section class="ids-col-12">
                  <h2 class="ids-text-section-02">endereço de corresponência</h2>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">CEP</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.deliveryAddress.zipCode }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">endereço</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.deliveryAddress.street }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">número</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.deliveryAddress.number }}
                  </p>
                </section>

                <section class="ids-col-6" *ngIf="dataPersonal.partner.deliveryAddress!.complement">
                  <h3 class="ids-text-label-small ids-pv-2">complemento</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.deliveryAddress.complement }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">bairro</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.deliveryAddress.district }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">cidade</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.deliveryAddress.city }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">estado</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.deliveryAddress.state }}
                  </p>
                </section>
              </ng-container>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">procurador</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">
                  o cônjuge ou convivente será representado por uma procução?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.attorneyData!.useAttorney }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.partner.attorneyData && dataPersonal.partner.attorneyData.useAttorney">
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">nome procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.attorneyData.fullName }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">CPF / CNPJ procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.attorneyData.documentNumber | idsMask : maskCpfCnpj }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">e-mail procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.attorneyData.email }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">telefone procurador</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.attorneyData.phone | idsMask : phone }}
                  </p>
                </section>
              </ng-container>

              <section class="ids-col-12">
                <h2 class="ids-text-section-02">dados adicionais</h2>
              </section>

              <section class="ids-col-12">
                <h3 class="ids-text-label-small ids-pv-2">
                  como pessoa física, sou empregador, trabalhador autônomo ou produtor rural e
                  mantenho funcionários registrados a meu serviço?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.additionalInformation.hasEmployee | simNao }}
                </p>
              </section>

              <section class="ids-col-12">
                <h3 class="ids-text-label-small ids-pv-2">
                  a venda deste imóvel será para um dos herdeiros legais (filho(a), neto(a), nora,
                  etc.)?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.additionalInformation.isSellingToFamily | simNao }}
                </p>
              </section>

              <section class="ids-col-12">
                <h3 class="ids-text-label-small ids-pv-2">
                  este proprietário do imóvel se trata de um Espólio (pessoa falecida, cujo o bem
                  ainda não foi partilhado), interdito (aquele que, por determinação legal, não
                  responde por seus atos) ou menor de 18 anos?
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.partner.additionalInformation.isUnderAge | simNao }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.partner.additionalInformation.isUnderAge">
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">que tipo de proprietário se trata?</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.additionalInformation.situation | lowercase }}
                  </p>
                </section>
              </ng-container>
            </li>
          </ul>
        </ng-container>
      </ids-accordion>

      <ids-accordion class="custom-accordion" header="dados para pagamento">
        <ng-container class="content">
          <ul>
            <li class="ids-row">
              <section class="ids-col-12">
                <h2 class="ids-text-section-02">sua conta</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nº do banco</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.payment.bankNumber }}
                </p>

                <h3 class="ids-text-label-small ids-pv-2">agência</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.payment.agencyNumber }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">agência</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.payment.agencyNumber }}
                </p>

                <h3 class="ids-text-label-small ids-pv-2">tipo de conta</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataPersonal.payment.accountType | accountTypeLabel }}
                </p>
              </section>

              <ng-container *ngIf="dataPersonal.partner && dataPersonal.partner.payment">
                <section class="ids-col-12">
                  <h2 class="ids-text-section-02">conta do cônjuge ou companheiro</h2>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">nº do banco</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.payment.bankNumber }}
                  </p>

                  <h3 class="ids-text-label-small ids-pv-2">agência</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.payment.agencyNumber }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">conta corrente</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.payment.accountNumber }}
                  </p>

                  <h3 class="ids-text-label-small ids-pv-2">tipo de conta</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ dataPersonal.partner.payment.accountType | accountTypeLabel }}
                  </p>
                </section>
              </ng-container>
            </li>
          </ul>
        </ng-container>
      </ids-accordion>


    <section class="ids-pt-4">
      <h3 class="ids-section-01-bold ids-pv-4 ids-mb-4 ids-mt-6">declaração</h3>

      <form [formGroup]="declarationForm" class="ids-card ids-p-4">
        <ids-form-selection>
          <input
            type="checkbox"
            name="hasDeclaration"
            formControlName="hasDeclaration"
            [invalid]="hasError"
            idsCheckbox
            aria-describedby="invalid-message"
          />
          Declaro, sob as penas da Lei, que as informações fornecidas acima expressam a realidade e
          podem ser comprovadas por documentação hábil, caso assim solicitado, principalmente no que
          se refere ao meu estado civil. Declaro ainda que as informações contidas na minha Certidão
          de Casamento permanecem válidas e inalteradas (quando for o caso).
        </ids-form-selection>
      </form>
    </section>
  </section>
</section>
